import React, { useMemo } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface PipelineFlowChartProps {
  loading?: boolean;
}

const PipelineFlowChart: React.FC<PipelineFlowChartProps> = ({ loading }) => {
  if (loading) {
    return (
      <div className="h-64 flex items-center justify-center">
        <div className="animate-pulse bg-gradient-to-r from-slate-200 via-slate-300 to-slate-200 w-full h-full rounded-xl"></div>
      </div>
    );
  }

  const flowData = useMemo(() => [
    { stage: 'Ingestion', throughput: 1200, latency: 45 },
    { stage: 'Validation', throughput: 1150, latency: 32 },
    { stage: 'Transform', throughput: 1100, latency: 78 },
    { stage: 'Aggregate', throughput: 1050, latency: 125 },
    { stage: 'Output', throughput: 1000, latency: 28 }
  ], []);

  return (
    <div className="w-full h-64 bg-gradient-to-br from-slate-50 to-white rounded-xl border border-slate-200 p-4">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={flowData}>
          <CartesianGrid strokeDasharray="2 2" stroke="#e2e8f0" opacity={0.3} />
          <XAxis 
            dataKey="stage" 
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: '#64748b' }}
          />
          <YAxis 
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: '#64748b' }}
          />
          <Tooltip />
          <Bar dataKey="throughput" fill="#6366f1" radius={[4, 4, 0, 0]} name="Throughput (rec/sec)" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PipelineFlowChart;